// extracted by mini-css-extract-plugin
export var active = "_d3-7";
export var container = "_d3-0";
export var evenWidth = "_d3-4";
export var large = "_d3-5";
export var outlet = "_d3-8";
export var slide = "_d3-2";
export var small = "_d3-6";
export var tab = "_d3-3";
export var tabs = "_d3-1";